import {Component, ElementRef, HostListener, Inject} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {SwiperOptions} from 'swiper';
import {PrivacyTermComponent} from '@frontend/shared';
import {APP_CONFIG} from "@frontend/app-config";
import {ActivatedRoute} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {getArtistDetails, GetArtistDetails, PublicState} from "@frontend/public-store";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'frontend-profile-page',
  templateUrl: './artist-profile-page.component.html',
  styleUrls: ['./artist-profile-page.component.scss'],
})
export class ArtistProfilePageComponent {
  OrganiceMusicConfig: SwiperOptions = {
    autoplay: false,
    spaceBetween: 15,
    breakpoints: {
      1199: {
        slidesPerView: 6,
      },
      991: {
        slidesPerView: 6,
      },
      767: {
        slidesPerView: 4,
      },
      375: {
        slidesPerView: 2.3,
      },
      320: {
        slidesPerView: 2.3,
      },
    },
  };
  OrganiceMusicConfigtwo: SwiperOptions = {
    autoplay: false,
    spaceBetween: 15,
    breakpoints: {
      1199: {
        slidesPerView: 6,
      },
      991: {
        slidesPerView: 6,
      },
      767: {
        slidesPerView: 4,
      },
      375: {
        slidesPerView: 2.3,
      },
      320: {
        slidesPerView: 2.3,
      },
    },
  };

  TutorialConfig: SwiperOptions = {
    autoplay: false,
    spaceBetween: 15,
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
    },
  };

  faqs = [
    'How to upload your music to Kwot.',
    'Sharing your music on other platforms.',
    'Payment model for artists.',
    'Managing your artist profile',
  ];

  isShowAll = false;
  artistId: any = null;
  artist: any = null;
  unsubscriber = new Subject();

  showAllFaqs = () => {
    this.isShowAll = !this.isShowAll;
  };

  constructor(
    private modelService: BsModalService,
    @Inject(APP_CONFIG) public appConfig: any,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private publicStore: Store<PublicState>
  ) {
    this.route.paramMap.subscribe(params => {
      // Extract the ID parameter from the URL
      this.artistId = params.get('id');
      if (this.artistId) {
        this.publicStore.dispatch(GetArtistDetails({artist_id: this.artistId}))
      }
    });

    this.publicStore
      .pipe(select(getArtistDetails))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((artist) => {
        if (artist) {
          this.artist = artist;
        }
      });
  }

  getDeviceInfo() {
    const userAgent = window.navigator.userAgent || window.navigator.vendor;
    const platform = window.navigator.platform;

    let os = "unknown";
    let browser = "unknown";
    if (/android/i.test(userAgent)) {
      os = "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      os = "iOS";
    } else if (/Win/.test(platform)) {
      os = "Windows";
    } else if (/Mac/.test(platform)) {
      os = "Mac OS";
    } else if (/Linux/.test(platform)) {
      os = "Linux";
    }

    if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
      browser = "Safari";
    } else if (/Chrome/.test(userAgent)) {
      browser = "Chrome";
    } else if (/Firefox/.test(userAgent)) {
      browser = "Firefox";
    } else if (/Edge/.test(userAgent)) {
      browser = "Edge";
    } else if (/MSIE|Trident/.test(userAgent)) {
      browser = "Internet Explorer";
    } else {
      browser = "Unknown";
    }

    return {
      userAgent: window.navigator.userAgent,
      platform: window.navigator.platform,
      appVersion: window.navigator.appVersion,
      language: window.navigator.language,
      os,
      browser
    };
  }

  ngOnInit() {
    const sectionId = window.location.hash;
    if (sectionId) {
      setTimeout(() => {
        const section = this.elementRef.nativeElement.querySelector(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      },600)
    }
    let device = this.getDeviceInfo();
    const os = device.os;
    const browser = device.browser;
    const webLink = "https://play.google.com/store/apps/details?id=com.kwot.music.android";
    const appStoreLink = "https://apps.apple.com/in/app/kwot/id1641283024";

    let linkToOpen;

    if (os === "Linux" || os === "Windows" || os === "Android") {
      linkToOpen = webLink;
    } else if (os === "iOS" || os === "Mac OS" || browser === 'Safari') {
      linkToOpen = appStoreLink;
    } else {
      linkToOpen = webLink;
    }
    // Open the determined link in a new tab
    const link = document.createElement('a');
    link.href = linkToOpen;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
  }

  showPrivacyTerms(activeTab: string) {
    const modelRef: BsModalRef = this.modelService.show(PrivacyTermComponent, {
      keyboard: true,
      animated: true,
      ignoreBackdropClick: false,
      class: 'modal-xl modal-dialog-centered',
      initialState: {
        showHeader: false
      }
    });
    modelRef.content.activeTab = activeTab;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const number =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (number > 100) {
      document.querySelectorAll('.appendClass').forEach((c) => {
        c.classList.add('text-smaller');
      });
    } else {
      document.querySelectorAll('.appendClass').forEach((c) => {
        c.classList.remove('text-smaller');
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

}
